'use client';

import useEventCallback from '@unifyapps/hooks/useEventCallback';
import type React from 'react';
import { useMemo } from 'react';
import { useParams, usePathname, useRouter, useSearchParams } from '../../navigation';
import { InterfaceRouterProvider } from '../hooks/useRouter';

const useNextRouter = () => {
  const pathParams = useParams();
  const nextRouter = useRouter();
  const searchParams = useSearchParams();
  const pathname = usePathname();

  // returns latest router state
  const getState = useEventCallback(() => ({
    pathParams,
    searchParams,
    pathname,
  }));

  return useMemo(() => {
    return {
      push: (url: string, useNativeRouter?: boolean) =>
        nextRouter.push(url, { useNativeRouter: !!useNativeRouter }),
      replace: (url: string, useNativeRouter?: boolean) =>
        nextRouter.replace(url, { useNativeRouter: !!useNativeRouter }),
      back: () => nextRouter.back(),
      pathParams,
      searchParams,
      pathname,
      getState,
    };
  }, [pathParams, searchParams, pathname, getState, nextRouter]);
};

function NextInterfaceRouterProvider(props: { children: React.ReactNode }) {
  const router = useNextRouter();

  return <InterfaceRouterProvider router={router}>{props.children}</InterfaceRouterProvider>;
}

export default NextInterfaceRouterProvider;
